import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface MessageModalProps {
  isMessageModalOpen: boolean;
  messages: string[];
  setMessageModalVisibility: (data: { isMessageModalOpen: boolean }) => void;
}

const MessageModal: React.FC<MessageModalProps> = ({
  isMessageModalOpen,
  setMessageModalVisibility,
  messages = []
}) =>
  isMessageModalOpen ? (
    <Modal
      centered
      isOpen={isMessageModalOpen}
      toggle={() => setMessageModalVisibility({ isMessageModalOpen: !isMessageModalOpen })}
      wrapClassName="modal-dark"
      size="md"
      zIndex={999999}
    >
      <ModalHeader
        toggle={() => setMessageModalVisibility({ isMessageModalOpen: !isMessageModalOpen })}
      >
        {getTranslationKey('userMessage.messageModal.title')}
      </ModalHeader>
      <ModalBody>
        {messages.map((m, k) => (
          <p key={k}>{m}</p>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() =>
            setMessageModalVisibility({
              isMessageModalOpen: !isMessageModalOpen
            })
          }
          color="primary"
        >
          {getTranslationKey('userMessage.messageModal.confirm')}
        </Button>
      </ModalFooter>
    </Modal>
  ) : null;

interface RootState {
  message: {
    isMessageModalOpen: boolean;
    messages: string[];
  };
}

function mapStateToProps({ message: { isMessageModalOpen, messages } }: RootState) {
  return {
    isMessageModalOpen,
    messages
  };
}

export default connect(mapStateToProps, actions)(MessageModal);
